import { normalSanatizerBRL } from "src/utils/functions";
import { ResultProporcional } from "../Proporcional"
export const ProporcionalTable = ({
    results
}: {
    results: ResultProporcional
}) => {
    return (
        <div className="max-h-[400px] overflow-y-auto m-auto overflow-x-auto">
            <table className="bg-white rounded w-full max-h-[400px] overflow-y-auto">
                <thead className="bg-gray-200 sticky top-0">
                    <tr>
                        <th className="px-4 py-2 text-center truncate">Evento</th>
                        <th className="px-4 py-2 text-center truncate">Valor</th>

                    </tr>
                </thead>
                <tbody>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">

                          Número de Dias de Ferias

                        </td>

                        <td className="px-4 py-2 text-center truncate border-r">
                            {results.DiasFerias}
                        </td>

                    </tr>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            Valor férias proporcionais
                        </td>

                        <td className="px-4 py-2 text-center truncate border-r">
                            R$ {normalSanatizerBRL(results.proporcional)}
                        </td>

                    </tr>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            1/3
                        </td>

                        <td className="px-4 py-2 text-center truncate border-r">
                            R$ {normalSanatizerBRL(results.Umterço)}

                        </td>

                    </tr>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            Valor total férias proporcionais
                        </td>

                        <td className="px-4 py-2 text-center truncate border-r">
                            R$ {normalSanatizerBRL(results.valorFinal)}

                        </td>

                    </tr>
                </tbody>
            </table>

        </div >
    )
}